const STYLES = {
  verified: { bg: "rgba(16,185,129,0.15)", text: "#10B981", border: "rgba(16,185,129,0.3)", label: "Verified" },
  reported: { bg: "rgba(59,130,246,0.15)", text: "#3B82F6", border: "rgba(59,130,246,0.3)", label: "Reported" },
  estimated: { bg: "rgba(245,158,11,0.15)", text: "#F59E0B", border: "rgba(245,158,11,0.3)", label: "Estimated" },
  modeled: { bg: "rgba(168,85,247,0.15)", text: "#A855F7", border: "rgba(168,85,247,0.3)", label: "Modeled" },
  unknown: { bg: "rgba(107,114,128,0.15)", text: "#9CA3AF", border: "rgba(107,114,128,0.3)", label: "Not publicly reported" },
};

export default function ConfidenceBadge({ level = "unknown", className = "" }) {
  const s = STYLES[level] || STYLES.unknown;
  return (
    <span data-testid={`confidence-badge-${level}`}
      className={`inline-flex items-center gap-1.5 font-mono text-[10px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full ${className}`}
      style={{ background: s.bg, color: s.text, border: `1px solid ${s.border}` }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.text }} />
      {s.label}
    </span>
  );
}
